import { DashboardFiltrosComponent } from '../../../componentes/dashboard-filtros/dashboard-filtros.component';
import { DashboardGrillaComponent } from '../../../componentes/dashboard-grilla/dashboard-grilla.component';
import { DashboardPanelComponent } from '../../../componentes/dashboard-panel/dashboard-panel.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { CheckboxComponent } from '../../../componentes/checkbox/checkbox.component';
import { MapaUnicoPuntoComponent } from '../../../auxiliares/mapa-unico-punto/mapa-unico-punto.component';
import { LuminariasRoutingModule } from './routing';
import { MapaFacilV2Component } from '../../../auxiliares/mapbox/mapa-facil-v2.component';
import { DateRangeSelectorComponent } from '../../../auxiliares/date-range-selector/date-range-selector.component';
import { ListadoLuminariasComponent } from './luminarias/listado-luminarias/listado-luminarias.component';
import { CrearEditarLuminariaComponent } from './luminarias/crear-editar-luminaria/crear-editar-luminaria.component';
import { MapaLuminariasComponent } from './mapa-luminarias/mapa-luminarias.component';
import { FlotanteLuminariasComponent } from './mapa-luminarias/flotante-luminarias/flotante-luminarias.component';
import { FiltrosLuminariasModalComponent } from './mapa-luminarias/filtros-luminarias-modal/filtros-luminarias-modal.component';
import { DetallesLuminariaComponent } from './luminarias/detalles-luminaria/detalles-luminaria.component';
import { ListadoConfigsEventosComponent } from '../../standalone/configs-eventos/listado-configs-eventos/listado-configs-eventos.component';
import { ListadoNotasComponent } from '../../standalone/notas/listado-notas/listado-notas.component';
import { ListadoReportesGenericosComponent } from '../../standalone/listado-reportes-genericos/listado-reportes-genericos.component';
import { MapDrawMapboxComponent } from '../../../auxiliares/map-draw-mapbox/map-draw-mapbox.component';
import { MapaUbicarComponent } from '../../../auxiliares/mapas/mapa-ubicar/mapa-ubicar.component';
import { CardComponent } from '../../../auxiliares/cards/cards.component';
import { PieChartLuminariasComponent } from './mapa-luminarias/pie-chart-luminarias/pie-chart-luminarias.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { EditarConfigLuminariaGPEComponent } from './luminarias/editar-config-luminaria-gpe/editar-config-luminaria-gpe.component';
import { DashboardLuminariasComponent } from './dashboard-luminarias/dashboard-luminarias.component';
import { DetalleMetricasDownlinksComponent } from './luminarias/detalles-luminaria/detalle-metricas-downlinks/detalle-metricas-downlinks.component';
import { ChartConsumoGPEComponent } from './dashboard-luminarias/chart-consumo/chart-consumo-gpe.component';
import { ChartComponent } from '../../../auxiliares/chart/chart.component';
import { ChartTiempoEncendidaComponent } from './dashboard-luminarias/chart-tiempo-encendida/chart-tiempo-encendida.component';
import { DetallesLuminariaInfoComponent } from './luminarias/detalles-luminaria/detalles-luminaria-info/detalles-luminaria-info.component';
import { DetallesLuminariaPerfilComponent } from './luminarias/detalles-luminaria/detalles-luminaria-perfil/detalles-luminaria-perfil.component';
import { PIEZAS_DETALLE } from '../../../componentes/detalle/detalle.components';
import { DetallesLuminariaGraficoComponent } from './luminarias/detalles-luminaria/detalles-luminaria-grafico/detalles-luminaria-grafico.component';
import { ListadoComandosHistoricoComponent } from './luminarias/detalles-luminaria/comandos-historico/listado-comandos-historico.component';
import { ListadoEventosLoraComponent } from './luminarias/detalles-luminaria/listado-eventos-lora/listado-eventos-lora.component';
import { SelectorTipoMapaComponent } from '../../standalone/selector-tipo-mapa/selector-tipo-mapa.component';
import { PieChartLuminariasModelosComponent } from './dashboard-luminarias/pie-chart-modelos/pie-chart-modelos.component';
import { GraficosComponent } from '../../../auxiliares/graficos/graficos.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HeatmapCortesComponent } from './dashboard-luminarias/heatmap-cortes/heatmap-cortes.component';
import { DetallesPerfilesComponent } from './luminarias/detalles-luminaria/detalles-perfiles/detalles-perfiles.component';
import { CambioModoComponent } from './luminarias/cambio-modo/cambio-modo.component';
import { ImportarUbicacionesComponent } from './luminarias/importar-ubicaciones/importar-ubicaciones.component';
import { ConfigActisComponent } from './luminarias/configuraciones-actis/configuraciones-actis.component';
import { EventosGenericosModule } from '../eventos-genericos/module';
import { AdministracionModule } from '../administracion/module';
import { MapCardComponent } from '../../../componentes/map-card/map-card.component';
import { ListadoAsignacionsComponent } from '../../standalone/asignacions/listado-asignacions/listado-asignacions.component';
import { DatePickerComponent } from '../../../componentes/date-picker/date-picker.component';
import { InfoBannerComponent } from '../../../componentes/info-banner/info-banner.component';
import { JerarquiaLuminariaComponent } from './luminarias/detalles-luminaria/jerarquia-luminaria/jerarquia-luminaria.component';
import { CronologiaPerfilComponent } from './luminarias/detalles-luminaria/cronologia-perfil/cronologia-perfil.component';
import { CronologiaComandosComponent } from './luminarias/detalles-luminaria/cronologia-comandos/cronologia-comandos.component';
import { GraficoEventosLuminariasComponent } from './grafico-eventos-luminarias/grafico-eventos-luminarias.component';
import { CurvaLuminariaChartComponent } from '../../standalone/modelos-dispositivos/curva-luminaria-chart/curva-luminaria-chart.component';

@NgModule({
  declarations: [
    //Luminarias
    ListadoLuminariasComponent,
    DetallesLuminariaComponent,
    DetallesLuminariaComponent,
    CrearEditarLuminariaComponent,
    DetallesLuminariaInfoComponent,
    DetallesLuminariaPerfilComponent,
    HeatmapCortesComponent,
    ImportarUbicacionesComponent,
    //Mapa Luminarias
    MapaLuminariasComponent,
    FlotanteLuminariasComponent,
    FiltrosLuminariasModalComponent,

    //Dashboard Luminarias
    DashboardLuminariasComponent,
    ChartConsumoGPEComponent,
    ChartTiempoEncendidaComponent,
    ListadoEventosLoraComponent,
  ],

  imports: [
    CommonModule,
    MatMenuModule,
    AuxiliaresModule,
    LuminariasRoutingModule,
    HighchartsChartModule,
    DragDropModule,
    EventosGenericosModule,
    AdministracionModule,
    CardComponent,
    MapDrawMapboxComponent,
    MapaUbicarComponent,
    MapaFacilV2Component,
    MapaUnicoPuntoComponent,
    DateRangeSelectorComponent,
    SelectorTipoMapaComponent,
    ChartComponent,
    GraficosComponent,
    DetalleMetricasDownlinksComponent,
    ListadoNotasComponent,
    PieChartLuminariasComponent,
    PieChartLuminariasModelosComponent,
    ListadoConfigsEventosComponent,
    EditarConfigLuminariaGPEComponent,
    ListadoComandosHistoricoComponent,
    DetallesLuminariaGraficoComponent,
    DetallesPerfilesComponent,
    ListadoReportesGenericosComponent,
    CambioModoComponent,
    ConfigActisComponent,
    MapCardComponent,
    ListadoAsignacionsComponent,
    DatePickerComponent,
    InfoBannerComponent,
    JerarquiaLuminariaComponent,
    CronologiaPerfilComponent,
    CronologiaComandosComponent,
    GraficoEventosLuminariasComponent,
    CurvaLuminariaChartComponent,
    CheckboxComponent,
    DashboardFiltrosComponent,
    DashboardGrillaComponent,
    DashboardPanelComponent,
    ...PIEZAS_DETALLE,
  ],
})
export class LuminariasModule {}
